
import React from "react";
import { Button } from "@/components/ui/button";
import { Save, Share2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/providers/AuthProvider";

interface ResponseActionsProps {
  onSave: () => void;
  onShareEmail: () => void;
  onShareSMS: () => void;
  onShareFacebook: () => void;
  isSaving: boolean;
}

const ResponseActions: React.FC<ResponseActionsProps> = ({
  onSave,
  onShareEmail,
  onShareSMS,
  onShareFacebook,
  isSaving,
}) => {
  const { user } = useAuth();

  return (
    <div className="flex space-x-4 mt-6 mb-2 justify-center">
      {user && (
        <Button
          onClick={onSave}
          variant="outline"
          className="flex items-center gap-2 border-heaven-gold hover:bg-heaven-gold/10"
          disabled={isSaving}
        >
          <Save className="h-5 w-5 text-heaven-gold" />
          <span>{isSaving ? "Saving..." : "Save Response"}</span>
        </Button>
      )}

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="flex items-center gap-2 border-heaven-gold hover:bg-heaven-gold/10"
          >
            <Share2 className="h-5 w-5 text-heaven-gold" />
            <span>Share</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="end" 
          className="bg-white border border-gray-100 shadow-lg"
        >
          <DropdownMenuLabel>Share Response</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onShareEmail} className="cursor-pointer">
            Email
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onShareSMS} className="cursor-pointer">
            Text Message
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onShareFacebook} className="cursor-pointer">
            Facebook
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ResponseActions;
